import Vue from 'vue'
import Vuex from 'vuex'
import getters from "./getters"
import user from "./modules/user"
import live from "./modules/live"
import permission from "./modules/permission"
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    live,
    permission
  },
  getters
});

export default store
